export const TOKEN_KEY = "hermannToken";
